import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import { COMMON, PERMISSION_CONSTANTS, ALL_ROUTES } from '../../global/Constants';
import { ActivityStatusType, ActivityType } from "../../global/Enum";
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import AuthService from '../../providers/AuthService';
import DataProvider from '../../providers/DataProvider';
import SyncServices from '../../providers/SyncServices';
import { toast } from 'react-toastify';
import $ from 'jquery';

class AcceptRejectButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            activity: {},
            reasons: [
                // { id: 1, reason: "Wrong Selection of session" },
                // { id: 2, reason: "Wrong Selection of Sub Activity" },
                // { id: 3, reason: "Wrong Entry of Farmer Commitment" },
                // { id: 4, reason: "Other" }
            ],
            selectedReasonId: 0,
            remark: "",
            isUpdate: false,
        }
    }

    componentDidMount() {
        toast.configure();
    }

    componentDidUpdate(prevState, prevProps) {
        if (prevProps.activity !== this.props.activity) {
            if (!this.state.isUpdate) {
                const { activity } = this.props;
                Utilities.LogPrint("ACTIVITY===>", activity);
                this.setState({ activity, isUpdate: true });

                // const showRejectActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.REJECT_ACTIVITY);
                // if (showRejectActivity?.view && activity.activity_status_id === ActivityStatusType.PENDING_REVIEW) {
                //     this.getAllReject();
                // }
            }
        }
    }

    getAllReject() {
        const { activity } = this.props;

        const rejectReasons = DataProvider.getInstance().getRejectReasons(activity?.activity_type_id);
        //Utilities.LogPrint("rejectReasons", rejectReasons);
        if (rejectReasons !== null && rejectReasons?.length > 0) {
            this.setState({
                reasons: rejectReasons,
            })
        }

        // this.setState({ isLoading: true });
        // const request = JSON.stringify({
        //     activity_type_id: activity?.activity_type_id,
        //     // page: 1,
        //     // perPage: 10,
        //     // sortOrder: "DESC"
        // });
        // try {
        //     ApiServices.getAllReject(request)
        //         .then(response => {
        //             Utilities.LogPrint("API_Activity_DATA: ---->", response);
        //             this.setState({ isLoading: false });
        //             if (response.success) {
        //                 const data = response.data;
        //                 if (data != null) {
        //                     this.setState({ reasons: data });
        //                 }
        //             } else {
        //                 alert(response.message);
        //                 Utilities.LogPrint("Status", response.message);
        //                 if (response.message !== undefined && response.message) {
        //                     this.setState({
        //                         errorMsg: response.message
        //                     });
        //                 }
        //             }
        //         }).catch(error => {
        //             this.setState({ isLoading: false, errorMsg: error });
        //         });
        // } catch (error) {
        //     this.setState({ isLoading: false, errorMsg: error });
        // }
    }

    handleAcceptClick = () => {
        const { activity } = this.props;
        //this.props.history.goBack();

        //SyncServices.updateActivityStatusId(activity.key, ActivityStatusType.COMPLETED);

        if (Utilities.isNetworkConnected()) {
            this.setState({ isLoading: true });
            const request = JSON.stringify({
                activity_id: activity?.activity_id,
                activity_status_id: ActivityStatusType.COMPLETED
            });
            try {
                ApiServices.editActivityById(request)
                    .then(response => {
                        this.setState({ isLoading: false });
                        if (response.success) {

                            const key = activity?.key ? activity.key : String(activity.activity_id);
                            SyncServices.updateActivityStatusId(key, ActivityStatusType.COMPLETED);
                            this.props.handleAcceptButton();

                        } else {
                            alert(response.message);
                            Utilities.LogPrint("Status", response.message);
                            if (response.message !== undefined && response.message) {
                                this.setState({
                                    errorMsg: response.message
                                });
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false, errorMsg: error });
                    });
            } catch (error) {
                this.setState({ isLoading: false, errorMsg: error });
            }
        } else {
            //this.props.handleAcceptButton();
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }


    handleOnChange(e) {
        Utilities.LogPrint('Selected Reason', e.target.value);
        this.setState({ selectedReasonId: parseInt(e.target.value) });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleRejectButton = () => {
        this.getAllReject();
        $('#rejectButton').trigger('click');
    }

    handleRejectSubmit = () => {
        const { activity } = this.props;
        const { selectedReasonId, remark } = this.state;

        let activityReject = {
            reject_id: selectedReasonId,
            reason: remark
        }
        //SyncServices.updateActivityStatusId(activity.key, ActivityStatusType.TO_RESUBMIT, rejectReason);

        if (Utilities.isNetworkConnected()) {

            this.setState({ isLoading: true });
            const request = JSON.stringify({
                activity_id: activity?.activity_id,
                reject_id: selectedReasonId,
                reason: remark,
                is_active: true,
            });
            Utilities.LogPrint("Req", request);
            try {
                ApiServices.addActivityReject(request)
                    .then(response => {
                        Utilities.LogPrint("AddActivityReject: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {

                            const key = activity?.key ? activity.key : String(activity.activity_id);
                            SyncServices.updateActivityStatusId(key, ActivityStatusType.TO_RESUBMIT, activityReject);
                            this.props.handleRejectButton();
                        } else {
                            alert(response.message);
                            Utilities.LogPrint("Status", response.message);
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            //this.props.handleRejectButton();
            toast.info('Please Check Your Network Connection!');
        }
    }

    isValid() {
        const { selectedReasonId } = this.state;
        return selectedReasonId === 0;
    }

    handleEditButton = () => {
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }
        const { activity } = this.props;
        //this.props.handleEditButton();
        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {
            this.props.history.push({
                pathname: ALL_ROUTES.EDIT_INDIVIDUAL_VISIT,
                state: { activity: activity, isToday: true }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
            this.props.history.push({
                pathname: ALL_ROUTES.EDIT_SAMPLE_DISTRIBUTION_ROUTE,
                state: { activity: activity, isToday: true }
            });

        } else if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
            this.props.history.push({
                pathname: ALL_ROUTES.EDIT_GROUP_MEETING_ROUTE,
                state: { data: activity }
            });

        } else if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
            // this.props.history.push({
            //     pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
            //     state: { activity: activity }
            //   });

            const params = JSON.stringify({
                activity_id: activity.activity_id
            });
            this.setState({ isLoading: true });
            try {
                ApiServices.getActivityById(params)
                    .then(response => {
                        this.setState({ isLoading: false });
                        if (response.success) {
                            Utilities.LogPrint("getActivityById", response.data);


                            const data = response?.data;
                            if (data !== null) {
                                let activityObj = activity;
                                activityObj.isEdit = true;
                                let dataObj = {
                                    data: {
                                        history: data?.history
                                    }
                                }
                                activityObj = { ...activityObj, ...dataObj }
                                Utilities.LogPrint("Final", activityObj);

                                this.props.history.push({
                                    pathname: ALL_ROUTES.EDIT_SAMPLE_TO_SALE,
                                    state: { activity: activityObj }
                                });
                            }
                        }
                    })
                    .catch(error => {
                        Utilities.LogPrint("getActivityById-catch", error);
                    });
            }
            catch (error) {
                //this.props.loaderCallback(false);
                Utilities.LogPrint("getActivityById-error", error);
            }
        }

    }

    handleDeleteButton = () => {
        if (!Utilities.isNetworkConnected()) {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
            return;
        }
        const { activity } = this.props;
        var params = JSON.stringify({
            activity_id: activity.activity_id,
            is_active: 0
        });
        this.setState({ isLoading: true });
        try {
            ApiServices.deleteActivity(params)
                .then(response => {
                    this.setState({ isLoading: false });
                    if (response.success) {
                        this.props.history.goBack();
                        Utilities.LogPrint("deleteActivity", response.message);
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteActivity-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteActivity-error", error);
        }
    }

    render() {
        const { activity } = this.props;
        const { isLoading } = this.state;

        const showEditActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.EDIT_ACTIVITY);
        const showDeleteActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DELETE_ACTIVITY);

        return (
            <div className="mt-2">

                {/* Accept & Reject Activity */}
                {this.showAcceptRejectButton(activity)}

                {/* Edit & Delete Activity */}
                <div className="row justify-content-end mt-md-3">
                    <div className="col-12 col-md-7 col-lg-4">
                        <div className="row">
                            <div className="col-12 d-flex mb-3" style={{ justifyContent: 'flex-end' }}>

                                <button className={showDeleteActivity?.delete ? "btn btn-primary w-50 mr-2" : "d-none"}
                                    onClick={this.handleDeleteButton}>
                                    {COMMON.DELETE}
                                </button>

                                <button className={showEditActivity?.edit ? "btn btn-primary w-50 ml-3" : "d-none"}
                                    onClick={this.handleEditButton}>
                                    {COMMON.EDIT}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>

                {isLoading ? <Loader /> : null}
            </div>
        )
    }

    showAcceptRejectButton = (activity) => {
        if (activity.activity_status_id !== ActivityStatusType.TO_RESUBMIT
            && activity.activity_status_id !== ActivityStatusType.COMPLETED) {

            const showAcceptActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ACCEPT_ACTIVITY);
            const showRejectActivity = AuthService.getRoleAccess(PERMISSION_CONSTANTS.REJECT_ACTIVITY);

            const { reasons } = this.state;
            return (
                <div className={showAcceptActivity?.view || showRejectActivity?.view ? "" : "d-none"}>

                    {/* Accept & Reject Activity */}
                    <div className="row justify-content-end mt-md-3 mt-lg-5">
                        <div className="col-12 col-md-7 col-lg-4">
                            <div className="row">
                                <div className="col-12 d-flex mb-3">
                                    <button
                                        className="btn btn-secondary d-inline-flex w-50 mr-2 align-items-center"
                                        onClick={() => { this.handleRejectButton() }}>{COMMON.REJECT}
                                        <i className="customic ic-down-arrow ml-auto"></i>
                                    </button>
                                    <button
                                        className="btn btn-primary w-50 ml-3"
                                        onClick={() => { this.handleAcceptClick() }}>
                                        {COMMON.ACCEPT}
                                    </button>

                                    {/* This Must be hidden */}
                                    <button id="rejectButton" type="button"
                                        data-toggle="modal" data-target="#rejectReasonPopup"
                                        className="d-none">placeholder</button>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Reject Reason Popup */}
                    {this.showRejectPopup(reasons)}

                </div>
            )
        }
    }

    showRejectPopup = (reasons) => {
        const { remark } = this.state;
        return (
            <div className="modal fade bottom-drawer reject-reason-popup" id="rejectReasonPopup" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h6 className="font-weight-medium">Select The Reason</h6>
                            <div className="form-group">

                                {
                                    reasons?.length ?
                                        reasons?.map(item => (
                                            <label className="custom-radio-container mt-3" key={item.reject_id}>
                                                {item.title}
                                                <input type="radio" name="radio" value={item.reject_id} onChange={(e) => this.handleOnChange(e)} />
                                                <span className="checkmark"></span>
                                            </label>
                                        )) : null
                                }

                            </div>
                            <div className="form-group"><label className="font-weight-medium">{COMMON.REMARKS}</label>
                                <textarea className="form-control" rows="3" name="remark"
                                    value={remark} onChange={this.changeHandler}></textarea>
                            </div>
                            <button className="btn btn-secondary w-50 float-right" data-dismiss="modal"
                                onClick={this.handleRejectSubmit}
                                disabled={this.isValid()}>{COMMON.SUBMIT}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AcceptRejectButton);
